export default __webpack_public_path__ + "static/media/video.ba053bf4.mp4";